import React from 'react';
import { useHistory } from 'react-router-dom';
import SLUGS from 'resources/slugs';
import {
    IconSubmenu
} from 'assets/icons';
import { convertSlugToUrl } from 'resources/utilities';
//import LogoComponent from './LogoComponent';
import SubMenuItemComponent from './SubMenuItemComponent';
import { getDataSession } from 'views/Utils/Common';
import Crear_factura from 'images/panel/menu/menu_light/crear_factura.svg';
import Desc_masiva from 'images/panel/menu/menu_light/descarga_masiva.svg';

import Articulos from 'images/panel/menu/menu_light/articulos.svg';
import Clientes from 'images/panel/menu/menu_light/clientes.svg';
import Impuestos from 'images/panel/menu/menu_light/impuestos.svg';
import Usuarios from 'images/panel/menu/menu_light/usuarios.svg';

let lista = [
        //Inventarios
        {
            menu: 'Inventarios',
            id: SLUGS.movimientosinventarioe,
            title: 'Entradas',
            imagen: IconSubmenu,
            onClick: SLUGS.movimientosinventarioe,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Inventarios',
            id: SLUGS.movimientosinventarios,
            title: 'Salidas',
            imagen: IconSubmenu,
            onClick: SLUGS.movimientosinventarios,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Inventarios',
            id: SLUGS.historialexistenciaentrada,
            title: 'Hist. Entradas',
            imagen: IconSubmenu,
            onClick: SLUGS.historialexistenciaentrada,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },             
        {
            menu: 'Inventarios',
            id: SLUGS.historialexistenciasalida,
            title: 'Hist. Salidas',
            imagen: IconSubmenu,
            onClick: SLUGS.historialexistenciasalida,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        //Ventas
        {
            menu: 'Ventas',
            id: SLUGS.cotizaciones,
            title: 'Cotizaciones',
            imagen: IconSubmenu,
            onClick: SLUGS.cotizaciones,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Ventas',
            id: SLUGS.pedidos,
            title: 'Pedidos',
            imagen: IconSubmenu,
            onClick: SLUGS.pedidos,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Ventas',
            id: SLUGS.remisiones,
            title: 'Remisiones',
            imagen: IconSubmenu,
            onClick: SLUGS.remisiones,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Ventas',
            id: SLUGS.vxfacturas,
            title: 'Facturas',
            imagen: Usuarios,
            onClick: SLUGS.vxfacturas,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        //Compras
        {
            menu: 'Compras',
            id: SLUGS.ordencompra,
            title: 'Orden de compra',
            imagen: Usuarios,
            onClick: SLUGS.ordencompra,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Compras',
            id: SLUGS.comprasList,
            title: 'Compras',
            imagen: Usuarios,
            onClick: SLUGS.comprasList,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Compras',
            id: SLUGS.recepcioncompra,
            title: 'Recepción mercancía',
            imagen: Usuarios,
            onClick: SLUGS.recepcioncompra,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
         //Cuentas por cobrar
         {
            menu: 'Cuentas_X_cobrar',
            id: SLUGS.creditocliente ,
            title: 'Cargos',
            imagen: Usuarios,
            onClick: SLUGS.creditocliente ,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Cuentas_X_cobrar',
            id: SLUGS.vxCobros,
            title: 'Abonos',
            imagen: Usuarios,
            onClick: SLUGS.vxCobros,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Cuentas_X_cobrar',
            id: SLUGS.clientes,
            title: 'Clientes',
            imagen: Usuarios,
            onClick: SLUGS.clientes,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        /*{
            menu: 'Cuentas_X_cobrar',
            id: SLUGS.vxotrosdocumentos,
            title: 'Devoluciones',
            imagen: Usuarios,
            onClick: SLUGS.vxotrosdocumentos,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },*/
         //Cuentas por pagar
         {
            menu: 'Cuentas_X_pagar',
            id: SLUGS.vxcreditosProveedores ,
            title: 'Cargos',
            imagen: Usuarios,
            onClick: SLUGS.vxcreditosProveedores ,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Cuentas_X_pagar',
            id: SLUGS.vxCargos,
            title: 'Creditos',
            imagen: Usuarios,
            onClick: SLUGS.vxCargos,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Cuentas_X_pagar',
            id: SLUGS.vxsaldosproveedores,
            title: 'Prox. Facturas',
            imagen: Usuarios,
            onClick: SLUGS.vxsaldosproveedores,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        /*{
            menu: 'Cuentas_X_pagar',
            id: SLUGS.vxotrosdocumentos,
            title: 'Devoluciones',
            imagen: Usuarios,
            onClick: SLUGS.vxotrosdocumentos,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },*/
        //Monitoreo
        {
            menu: 'Venta_en_Ruta',
            id: SLUGS.vxubicacion,
            title: 'Ubicacion',
            imagen: IconSubmenu,
            onClick: SLUGS.vxubicacion,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Venta_en_Ruta',
            id: SLUGS.vxrecorrido,
            title: 'Recorrido',
            imagen: IconSubmenu,
            onClick: SLUGS.vxrecorrido,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        //Venta en Ruta
        {
            menu: 'Venta_en_Ruta',
            id: SLUGS.vxagentes,
            title: 'Agentes',
            imagen: Usuarios,
            onClick: SLUGS.vxagentes,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        }, 
        {
            menu: 'Venta_en_Ruta',
            id: SLUGS.vxentregas,
            title: 'Entregas',
            imagen: Usuarios,
            onClick: SLUGS.vxentregas,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Venta_en_Ruta',
            id: SLUGS.vxvisitas,
            title: 'Visitas',
            imagen: Usuarios,
            onClick: SLUGS.vxvisitas,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Venta_en_Ruta',
            id: SLUGS.vxplanvisita,
            title: 'Planes de Visita',
            imagen: Usuarios,
            onClick: SLUGS.vxplanvisita,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Venta_en_Ruta',
            id: SLUGS.vxrutas,
            title: 'Rutas',
            imagen: Usuarios,
            onClick: SLUGS.vxrutas,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Venta_en_Ruta',
            id: SLUGS.vxgruporutas,
            title: 'Grupo Rutas',
            imagen: Usuarios,
            onClick: SLUGS.vxgruporutas,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Venta_en_Ruta',
            id: SLUGS.vxrazonvisitas,
            title: 'Razon de Visita',
            imagen: Usuarios,
            onClick: SLUGS.vxrazonvisitas,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },    
        {
            menu: 'Venta_en_Ruta',
            id: SLUGS.ConfigAppMaxventas,
            title: 'Config.App Maxventas',
            imagen: Usuarios,
            onClick: SLUGS.ConfigAppMaxventas,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        //Catalogos
        {
            menu: 'Catalogos',
            id: SLUGS.rolesclaves,
            title: 'Roles Claves',
            imagen: Usuarios,
            onClick: SLUGS.rolesclaves,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA'
        },
        {
            menu: 'Catalogos',
            id: SLUGS.rolespermisos,
            title: 'Asignar permisos',
            imagen: Usuarios,
            onClick: SLUGS.rolespermisos,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA'
        },
        {
            menu: 'Catalogos',
            id: SLUGS.almacenes,
            title: 'Almacenes',
            imagen: Articulos,
            onClick: SLUGS.almacenes,
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Punto_de_venta',
            id: SLUGS.pvformascobro,
            title: 'Formas de cobro',
            imagen: IconSubmenu,
            onClick: SLUGS.pvformascobro,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Punto_de_venta',
            id: SLUGS.pvcajeros,
            title: 'Cajeros',
            imagen: IconSubmenu,
            onClick: SLUGS.pvcajeros,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Punto_de_venta',
            id: SLUGS.pvcajas,
            title: 'Cajas',
            imagen: IconSubmenu,
            onClick: SLUGS.pvcajas,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Punto_de_venta',
            id: SLUGS.pvmovimientos,
            title: 'Movimientos',
            imagen: IconSubmenu,
            onClick: SLUGS.pvmovimientos,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Punto_de_venta',
            id: SLUGS.pvcortes,
            title: 'Cortes',
            imagen: IconSubmenu,
            onClick: SLUGS.pvcortes,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Punto_de_venta',
            id: SLUGS.pvdocumentos,
            title: 'Documentos',
            imagen: IconSubmenu,
            onClick: SLUGS.pvdocumentos,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Catalogos',
            id: SLUGS.listaprecios,
            title: 'Lista Precios',
            imagen: Articulos,
            onClick: SLUGS.listaprecios,
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Catalogos',
            id: SLUGS.categorias,
            title: 'Categorias',
            imagen: Impuestos,
            onClick: SLUGS.categorias,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA'
        },
        {
            menu: 'Catalogos',
            id: SLUGS.etiquetas,
            title: 'Etiquetas',
            imagen: Impuestos,
            onClick: SLUGS.etiquetas,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA'
        },
        {
            menu: 'Catalogos',
            id: SLUGS.atributos,
            title: 'Atributos',
            imagen: Impuestos,
            onClick: SLUGS.atributos,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA'
        },
        {
            menu: 'Catalogos',
            id: SLUGS.clientes,
            title: 'Clientes',
            imagen: Clientes,
            onClick: SLUGS.clientes,
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Catalogos',
            id: SLUGS.proveedores,
            title: 'Proveedores',
            imagen: Clientes,
            onClick: SLUGS.proveedores,
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Catalogos',
            id: SLUGS.Cobrador,
            title: 'Cobradores',
            imagen: Impuestos,
            onClick: SLUGS.Cobrador,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Catalogos',
            id: SLUGS.Vendedor,
            title: 'Vendedores',
            imagen: Impuestos,
            onClick: SLUGS.Vendedor,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Catalogos',
            id: SLUGS.usuarios,
            title: 'Usuarios',
            imagen: Usuarios,
            onClick: SLUGS.usuarios,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA'
        },
        {
            menu: 'Catalogos',
            id: SLUGS.condicionpago,
            title: 'Condicion Pago',
            imagen: Usuarios,
            onClick: SLUGS.condicionpago,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA'
        },
        {
            menu: 'Catalogos',
            id: SLUGS.vxcuentasbancos,
            title: 'Cuentas de Bancos',
            imagen: Usuarios,
            onClick: SLUGS.vxcuentasbancos,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA'
        },
        {
            menu: 'Catalogos',
            id: SLUGS.vxformascobroscc,
            title: 'Formas de Cobros',
            imagen: Usuarios,
            onClick: SLUGS.vxformascobroscc,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA'
        },
        {
            menu: 'Catalogos',
            id: SLUGS.altiria,
            title: 'Altiria',
            imagen: Usuarios,
            onClick: SLUGS.altiria,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA'
        },
        {
            menu: 'Catalogos',
            id: SLUGS.smscobranza,
            title: 'SMS Cobranza',
            imagen: Usuarios,
            onClick: SLUGS.smscobranza,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA'
        },
        {
            menu: 'Catalogos',
            id: SLUGS.listaSMS,
            title: 'SMS Enviados',
            imagen: Usuarios,
            onClick: SLUGS.listaSMS,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA'
        },
        

        {
            menu: 'Mensajes',
            id: SLUGS.mensajes,
            title: 'Preguntas/Mensajes',
            imagen: Crear_factura,
            onClick: SLUGS.mensajes,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Mensajes',
            id: SLUGS.lognotificaciones,
            title: 'Sistema',
            imagen: Desc_masiva,
            onClick: SLUGS.lognotificaciones,
            EMPRESA: 'EMPRESA',
        },
        {
            menu: 'Mensajes',
            id: SLUGS.respuestasMensajes,
            title: 'Resp. Automáticas',
            imagen: Desc_masiva,
            onClick: SLUGS.respuestasMensajes,
            EMPRESA: 'EMPRESA',
        },
        {
            menu: 'Mensajes',
            id: SLUGS.tiposMensajes,
            title: 'Tipos mensajes',
            imagen: Desc_masiva,
            onClick: SLUGS.tiposMensajes,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
        },
        
        
        
       /* {
            menu: 'Movimientos',
            id: SLUGS.vxpedidos,
            title: 'Pedidos',
            imagen: Usuarios,
            onClick: SLUGS.vxpedidos,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Movimientos',
            id: SLUGS.vxventas,
            title: 'Ventas',
            imagen: Usuarios,
            onClick: SLUGS.vxventas,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },*/
        /*{
            menu: 'Movimientos',
            id: SLUGS.vxsaldosproveedores,
            title: 'Calendario Pago',
            imagen: Usuarios,
            onClick: SLUGS.vxsaldosproveedores,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Movimientos',
            id: SLUGS.vxfacturas,
            title: 'Control de Facturas',
            imagen: Usuarios,
            onClick: SLUGS.vxfacturas,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        
        {
            menu: 'Movimientos',
            id: SLUGS.vxotrosdocumentos,
            title: 'Otros Documentos',
            imagen: Usuarios,
            onClick: SLUGS.vxotrosdocumentos,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
       */ 
     /*
        {
            menu: 'Articulos',
            id: SLUGS.articulos,
            title: 'Listado',
            imagen: Articulos,
            onClick: SLUGS.articulos,
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        }, 
        {
            menu: 'Articulos',
            id: SLUGS.diferencias,
            title: 'Comparativa',
            imagen: Articulos,
            onClick: SLUGS.diferencias,
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        }, 
        
         {
            menu: 'Articulos',
            id: SLUGS.publicadormasivo,
            title: 'Publicador masivo',
            imagen: Articulos,
            onClick: SLUGS.publicadormasivo,
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        }, 
         {
            menu: 'Articulos',
            id: SLUGS.asignacionautomatica,
            title: 'Asignación automática',
            imagen: Articulos,
            onClick: SLUGS.asignacionautomatica,
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        }, 
        {
            menu: 'Ordenes',
            id: SLUGS.cotizaciones,
            title: 'Cotizaciones',
            imagen: Movimientos,
            onClick: SLUGS.cotizaciones,
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Ordenes',
            id: SLUGS.ordenes,
            title: 'Pedidos',
            imagen: Movimientos,
            onClick: SLUGS.ordenes,
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Ordenes',
            id: SLUGS.remisiones,
            title: 'Remisiones',
            imagen: Movimientos,
            onClick: SLUGS.remisiones,
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
         */
        /*{
            menu: 'Mensajes',
            id: SLUGS.mensajes,
            title: 'Preguntas',
            imagen: Crear_factura,
            onClick: SLUGS.mensajes,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Mensajes',
            id: SLUGS.lognotificaciones,
            title: 'Notificaciones sistema',
            imagen: Desc_masiva,
            onClick: SLUGS.lognotificaciones,
            EMPRESA: 'EMPRESA',
        },
        {
            menu: 'Mensajes',
            id: SLUGS.respuestasMensajes,
            title: 'Respuestas automáticas',
            imagen: Desc_masiva,
            onClick: SLUGS.respuestasMensajes,
            EMPRESA: 'EMPRESA',
        },
        {
            menu: 'Mensajes',
            id: SLUGS.tiposMensajes,
            title: 'Tipos mensajes',
            imagen: Desc_masiva,
            onClick: SLUGS.tiposMensajes,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
        },
        {
            menu: 'Compras',
            id: SLUGS.ordencompra,
            title: 'Ordenes compras',
            imagen: Movimientos,
            onClick: SLUGS.ordencompra,
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Compras',
            id: SLUGS.recepcioncompra,
            title: 'Recepcion compras',
            imagen: Movimientos,
            onClick: SLUGS.recepcioncompra,
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Compras',
            id: SLUGS.comprasList,
            title: 'Compras',
            imagen: Movimientos,
            onClick: SLUGS.comprasList,
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            menu: 'Catalogos',
            id: SLUGS.impuestos,
            title: 'Impuestos',
            imagen: Impuestos,
            onClick: SLUGS.impuestos,
            ADMINISTRADOR: 'ADMINISTRADOR'
        },*/
        /*{
            menu: 'Catalogos',
            id: SLUGS.empresas,
            title: 'Empresas',
            imagen: Usuarios,
            onClick: SLUGS.empresas,
            ADMINISTRADOR: 'ADMINISTRADOR',
        },
        
        {
            menu: 'Catalogos',
            id: SLUGS.vxgruporutas,
            title: 'Grupo Rutas',
            imagen: Usuarios,
            onClick: SLUGS.vxgruporutas,
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        }*/
    
    ];



function SidebarOptionsComponent({ menu }) {
    const { push } = useHistory();

    function onClick(slug, parameters = {}) {
        push(convertSlugToUrl(slug, parameters));
    }

    function renderSwitch() {
        var rol = getDataSession('rol');
        var menua = getDataSession('menu');
        return lista.map((item) => {

            return (menua === item.menu && item.menu === menu && item.hasOwnProperty(rol)) ? (
                <SubMenuItemComponent
                    key={item.id + "sub"}
                    id={item.id}
                    title={item.title}
                    icon={IconSubmenu}
                    onClick={() => onClick(item.id)}
                />
            ) : (
                ''
            );
        });
    }

    return (
        <>

            {renderSwitch()}

        </>
    );
}

export default SidebarOptionsComponent;
